export default {
  quickLinks: 'Quick Links',
  support: 'Support',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  footerDescription: 'Your digital companion for pet care, making love more meaningful and care more effortless.',
  craftedWith: 'Crafted with love for pets',
  allRightsReserved: 'All rights reserved',
  availableLanguages: 'Available in',
  multiLanguageSupport: 'Multi-language support'
};